import { render } from "./AddGarden.vue?vue&type=template&id=10a0df12"
import script from "./AddGarden.vue?vue&type=script&lang=js"
export * from "./AddGarden.vue?vue&type=script&lang=js"

import "./AddGarden.vue?vue&type=style&index=0&id=10a0df12&lang=scss"
import "./AddGarden.vue?vue&type=style&index=1&id=10a0df12&lang=css"

import exportComponent from "/home/ubuntu/jalizan/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__